import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Close from '@material-ui/icons/Close';

import * as actions from '../../../../actions/api.form.actions';
import MultiSelectInput from '../../../inputs/MultiSelectInput';
import { TypeDropdownIcon } from '../../../../images/icons/WrapSvg';

import Task from './Task';

function searchTree(elements, codigo) {
    console.log(elements, codigo);
    let i;
    let result = null;
    if (elements && elements.length >= 0) {
        for (i = 0; result === null && i < elements.length; i++) {
            if (elements[i].codigo === codigo) {
                result = elements[i];
            }
            if (result === null && elements[i].hijos) result = searchTree(elements[i].hijos, codigo);
        }
    }
    return result;
}

class Options extends React.Component {
    state = {
        valor: '',
        comment: '',
        point: 0,
        correction: 0,
        message: undefined,
        intervalId: undefined,
        desactivado: false,
    };

    static getDerivedStateFromProps(props, state) {
        const { data, parentDeactivated, instance, instance_changes } = props;
        if (
            data !== state.data ||
            parentDeactivated !== state.parentDeactivated ||
            instance_changes !== state.instance_changes
        ) {
            const info = data.catalogo
                ? instance && instance.catalogos && instance.catalogos[data.catalogo]
                    ? instance.catalogos[data.catalogo]
                    : {}
                : instance && instance.entidades && instance.entidades[data.entidad]
                    ? instance.entidades[data.entidad]
                    : {};

            state.info = info;
            state.instance_changes = instance_changes;

            let valores = [];
            if (data.filtro) {
                let filtro = searchTree(instance.tabs, data.filtro);
                let validIds =
                    instance &&
                        instance.entidades &&
                        filtro &&
                        instance.entidades[filtro.entidad] &&
                        instance.entidades[filtro.entidad][filtro.valor] &&
                        instance.entidades[filtro.entidad][filtro.valor][data.entidad]
                        ? instance.entidades[filtro.entidad][filtro.valor][data.entidad]
                        : [];
                while (filtro && filtro.filtro) {
                    filtro = searchTree(instance.tabs, filtro.filtro)
                    if (instance &&
                        instance.entidades &&
                        filtro &&
                        instance.entidades[filtro.entidad] &&
                        instance.entidades[filtro.entidad][filtro.valor] &&
                        instance.entidades[filtro.entidad][filtro.valor][data.entidad]) {
                        // eslint-disable-next-line 
                        validIds = validIds.filter(value => instance.entidades[filtro.entidad][filtro.valor][data.entidad].includes(value))
                    }
                }

                valores = data.catalogo
                    ? info && info.valores
                        ? info.valores
                            .sort((a, b) => (a.orden > b.orden ? 1 : -1))
                            .map((f) => {
                                return { label: f.valor, value: f.id, puntuacion: f.puntuacion };
                            })
                        : []
                    : Object.keys(info).reduce((arr, key) => {
                        if (validIds.indexOf(parseInt(info[key].id, 10)) >= 0) {
                            arr.push({
                                label: info[key].nombre,
                                value: info[key].id,
                                puntuacion: 100,
                            });
                        }
                        return arr;
                    }, []);
            } else {
                valores = data.catalogo
                    ? info && info.valores
                        ? info.valores
                            .sort((a, b) => (a.orden > b.orden ? 1 : -1))
                            .map((f) => {
                                return { label: f.valor, value: f.id, puntuacion: f.puntuacion };
                            })
                        : []
                    : Object.keys(info).map((key) => {
                        return { label: info[key].nombre, value: info[key].id, puntuacion: 100 };
                    });
            }
            state.valores = valores;
            state.valor = data.valor
                ? valores.find((x) => x.value.toString() === data.valor.toString())
                : undefined;

            state.desactivado = data.desactivado;
            state.parentDeactivated = parentDeactivated;
            state.data = data;
            return state;
        }
        return null;
    }

    handleChange = (item) => {
        const valor = item.value;

        const selectedOption = valor
            ? this.state.valores.find((f) => f.value.toString() === valor.toString())
            : undefined;
        const percentage = selectedOption
            ? selectedOption.puntuacion || selectedOption.puntuacion === 0
                ? selectedOption.puntuacion
                : 100
            : 0;

        if (
            this.state.data &&
            this.state.data.camposfiltrados &&
            this.state.data.camposfiltrados.length > 0
        ) {
            this.state.data.camposfiltrados.map((i) =>
                this.props.setValue(i, undefined, '', false, {}, percentage),
            );
        }

        this.props.setValue(this.state.data.codigo, valor, '', false, {}, percentage);
        this.setState({ valor: item });
    };

    handleDeactive = (data, checked) => {
        if (
            this.state.data &&
            this.state.data.camposfiltrados &&
            this.state.data.camposfiltrados.length > 0
        ) {
            this.state.data.camposfiltrados.map((i) =>
                this.props.setValue(i, undefined, '', checked, {}),
            );
        }
        this.props.setValue(data.codigo, undefined, '', checked, {});
        this.setState({ desactivado: checked, valor: '' });
    };

    render() {
        const { data, last, intl, editable } = this.props;
        const { valor, desactivado, parentDeactivated, valores } = this.state;

        const component = (
            <div className="flex_full_row align_botton">
                <MultiSelectInput
                    defaultValue={valor}
                    placeHolder={intl.formatMessage({
                        id: 'options_field_label',
                    })}
                    options={valores}
                    onChange={this.handleChange}
                    isSimple
                />
                <Close
                    className="c_lipstick hand"
                    onClick={(event) => this.handleChange({ value: undefined })}
                />
            </div>
        );
        return (
            <Task
                key={data.codigo}
                data={data}
                editable={editable}
                value={valor}
                icon={<TypeDropdownIcon color="primary" />}
                text="type_label_options"
                last={last}
                component={component}
                desactivado={desactivado}
                parentDeactivated={parentDeactivated}
                onDeactive={this.handleDeactive}
            />
        );
    }
}

Options.propTypes = {
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        instance: state.instance,
        instance_changes: state.instance_changes,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectIntl(Options));



// WEBPACK FOOTER //
// ./src/components/complex/forms/types/Options.js